import React from 'react'
import {
  DialogContent,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material'
import { ErrorBoundary } from 'react-error-boundary'
import { useTranslation } from 'react-i18next'

import { useCustomer, useUpdateCustomer } from './admin-api'

type LLMProviderType = 'chat-gpt' | 'chat-azure' | 'chat-vertex' | null

const AdminSwitchProviderContent = () => {
  const { t } = useTranslation('legacy', { keyPrefix: 'admin.switch_provider' })
  const customerQuery = useCustomer()
  const updateCustomerMutation = useUpdateCustomer()

  const { customer } = customerQuery.data
  const currentProvider = customer.llmProvider

  const handleChange = (provider: LLMProviderType) => {
    if (currentProvider !== provider) {
      updateCustomerMutation.mutate({ llmProvider: provider })
    }
  }

  return (
    <DialogContent sx={{ pt: '0px !important' }}>
      <Typography fontWeight="bold" mb={1}>
        {t('llm_provider_selection')}
      </Typography>
      <Typography variant="body2" color="text.secondary" mb={2}>
        {t('provider_description')}
      </Typography>
      <FormControl>
        <RadioGroup
          value={currentProvider ?? 'default'}
          onChange={(e) =>
            handleChange(e.target.value === 'default' ? null : (e.target.value as LLMProviderType))
          }
        >
          <FormControlLabel
            value="chat-gpt"
            control={<Radio color="secondary" />}
            label={t('openai_gpt')}
          />
          <FormControlLabel
            value="chat-azure"
            control={<Radio color="secondary" />}
            label={t('azure_gpt')}
          />
          <FormControlLabel
            value="chat-vertex"
            control={<Radio color="secondary" />}
            label={t('vertex_ai')}
          />
          <FormControlLabel
            value="default"
            control={<Radio color="secondary" />}
            label={t('model_default')}
          />
        </RadioGroup>
      </FormControl>
    </DialogContent>
  )
}

export const AdminSwitchProvider = () => {
  const { t } = useTranslation('legacy', { keyPrefix: 'admin.switch_provider' })
  return (
    <ErrorBoundary fallback={<div>{t('something_went_wrong')}</div>}>
      <React.Suspense fallback={<div>{t('loading')}</div>}>
        <AdminSwitchProviderContent />
      </React.Suspense>
    </ErrorBoundary>
  )
}
